import Connector from './connector';
import { EntityDetailsIncomeStatement as Component } from './EntityDetailsIncomeStatement';

const EntityDetailsIncomeStatement = () => <Connector component={Component} />;

export default EntityDetailsIncomeStatement;
